<template lang="pug">
  #about(v-cloak)
    .box
      .box-header.with-border.register-header
        .title
          span HitomeQコネクトについて
      .box-body.text-center
        .application.mb-2
          img(src="@/assets/login-title.png")
        .version.mb-3
          span Version {{ version }}
        .about-service.mb-4
          button.btn.mr-3(type="button" @click="showTerms") 利用規約
          button.btn.mr-3(type="button" @click="showSpecification") サービス仕様書
          button.btn(type="button" @click="showLicense") 著作権情報
        .copyright
          span HitomeQコネクト
        .copyright
          span Copyright 2019 KONICAMINOLTA. All rights reserved.
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

/**
 * HitomeQコネクトについて画面コンポーネント
 */
@Component
export default class About extends Vue {
  /** バージョン */
  private version: string = process.env.VUE_APP_VERSION ? process.env.VUE_APP_VERSION : "";
  /** 利用規約PDF */
  private termPdfUrl: string = "HitomeQコネクト 利用規約.pdf";
  /** サービス仕様書PDF */
  private specificationPdfUrl: string = "HitomeQコネクト サービス仕様書.pdf";
  /** ライセンスTEXT */
  private licenseHtmlUrl: string = "license.html";

  /**
   * vue lifecycle created
   */
  private async created(): Promise<void> {
    return;
  }

  /**
   * 利用規約を別ウィンドウで開く
   */
  private showTerms(): void {
    window.open(this.termPdfUrl, "_blank");

    return;
  }

  /**
   * サービス仕様書を別ウィンドウで開く
   */
  private showSpecification(): void {
    window.open(this.specificationPdfUrl, "_blank");

    return;
  }

  /**
   * ライセンステキストを別ウィンドウで開く
   */
  private showLicense(): void {
    window.open(this.licenseHtmlUrl, "_blank");

    return;
  }
}
</script>

<style lang="scss" scoped>
// 親要素からネストしてスタイルを指定する
#about {
  max-width: 980px;
  margin-left: auto;
  margin-right: auto;

  .btn {
    width: 150px;
  }
}
</style>
